export default __webpack_public_path__ + "static/media/cp_geo_nc.9f3379ef.svg";